// extracted by mini-css-extract-plugin
export default {"reportDetailsWrapper":"ReportDetails_reportDetailsWrapper__nVbwz"};